<div *ngFor="let notification of notificationTypes">
  <mat-radio-group [(ngModel)]="notificationSettings.notificationPreference" class="flex flex-col">
    <mat-radio-button [value]="notification.notificationPreference" class="m-b-5">{{notification.title}}
      <div class="hint">
        {{notification.description}}
      </div>
    </mat-radio-button>
  </mat-radio-group>
</div>
